import fetchApi from "../fetchApi";
export const validateVoidCard = async ({ prn }) => {
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/void-cards/${prn}/validate`, options);
};
